<template>
    <div class="ah-page invoice-add-page">
        <div class="page-header bottom-margin" id="invoice-edit-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">申請開發票</h1>
                        <h1 v-if="form.sno">編輯發票</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" :label-position="isMobile() ? 'top' : 'right'" label-width="200px">
            <div class="ah-container">
                <!-- 退件原因 -->
                <el-alert style="margin-bottom: 20px" type="error" title="退件原因：" v-if="form.sno && form.status == 4" :closable="false">
                    <div>{{ auditProgress.rsn }}</div>
                    <div>{{ `${auditProgress.stF_NAM} ` }}{{ auditProgress.sdat | dateFormater("YYYY-MM-dd") }}</div>
                </el-alert>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">發票資料</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="ioo" label="單號" v-if="form.ioo != null">
                            <el-input v-model="form.ioo" :disabled="true" />
                        </el-form-item>
                        <el-form-item prop="typ" label="發票類型">
                            <el-radio-group v-model="form.typ" @change="handleTypeChange">
                                <el-radio v-for="item in invoiceTypeOptions" :key="item.key" :label="item.key">
                                    <template v-if="item.value === '核銷'">
                                        <ahRichPopInfo title="核銷" :width="330">
                                            <template slot="content">
                                                <div style="text-align: left">
                                                    <ol>
                                                        <li>暫收款（如訂金）等後續再開立<ahTip>財務 / 核銷轉開發票</ahTip></li>
                                                        <li>補助款認列收入。</li>
                                                        <li>不開發票的現金認列營收。</li>
                                                    </ol>
                                                </div>
                                            </template>
                                            <span class="tip">{{ item.value }}</span>
                                        </ahRichPopInfo>
                                    </template>
                                    <span v-else>{{ item.value }}</span>
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="isEInvoiceEnabled" label="使用平台開立電子發票">
                            <el-checkbox v-model="form.createE_Invoice" />
                        </el-form-item>
                        <el-form-item prop="isProject" label="專案發票">
                            <el-radio-group v-model="form.isProject" @change="handleIsProjectChange">
                                <el-radio :label="true" border>專案發票</el-radio>
                                <el-radio :label="false" border> 非專案發票 </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="未開發票專案" v-if="form.isProject">
                            <ah-project-card
                                v-for="project in selectedProjects"
                                :key="'project-' + project.sno"
                                :project="project"
                                :show-detail-btn="false"
                                @installmemtCheckChanged="handleProjectInstallmentCheckChange"
                                @remove="removeDisplayProject(project.sno)"
                                @keydown.native.capture.enter="preventIMESelect"
                            />
                            <div>
                                <el-button v-if="!isShowProjectSelect && !isQR()" @click="handleAddProjectBtnClick">增加專案</el-button>
                                <div v-if="isShowProjectSelect">
                                    <ah-select-project ref="projectSelect" v-model="selectedProjectSno" @change="handleProjectSelectChange" @blur="handleProjectSelectBlur" style="margin-right: 5px" />
                                    <el-popconfirm
                                        v-if="isAuth('C01') && !isQR()"
                                        title="將前往新增，新增後會自動返回。"
                                        confirm-button-text="前往新增"
                                        cancel-button-text="取消"
                                        icon="el-icon-warning"
                                        @confirm="onAddProjectBtnClick"
                                    >
                                        <el-button icon="el-icon-plus" slot="reference" :disabled="!isAuth('C01') || isQR()"></el-button>
                                    </el-popconfirm>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item :label="form.typ === 1 ? 'INVOICE摘要' : '發票摘要'" prop="description" :rules="rules.description">
                            <div style="display: flex">
                                <el-input
                                    v-model="form.description"
                                    type="textarea"
                                    :maxlength="100"
                                    show-word-limit
                                    class="ah-el-input-textarea"
                                    autosize
                                    resize="none"
                                    @keydown.enter.native="onDescriptionInputKeydown($event)"
                                ></el-input>
                                <el-button v-if="form.isProject" size="small" plain type="basic" style="margin-left: 10px" icon="el-icon-refresh-left" @click="onRefreshDescription"></el-button>
                            </div>
                        </el-form-item>
                        <el-form-item prop="vdR_SNO" label="買受人(客戶)">
                            <ah-select-client v-model="form.vdR_SNO" @change="handleClientSelectChange" />
                            <el-popconfirm
                                v-if="isAuth('C02') && !isQR()"
                                title="將前往新增，新增後會自動返回。"
                                confirm-button-text="前往新增"
                                cancel-button-text="取消"
                                icon="el-icon-warning"
                                @confirm="onAddVenderBtnClick"
                            >
                                <el-button icon="el-icon-plus" slot="reference" :disabled="!isAuth('C02') || isQR()"></el-button>
                            </el-popconfirm>
                        </el-form-item>
                        <el-form-item label="買受人統一編號" prop="bsn" :rules="form.typ === 3 ? rules.bsn : [{ required: false }]">
                            <el-input v-model.trim="form.bsn" readonly class="bsn-input" :disabled="true" style="width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item v-if="isEInvoiceEnabled && form.createE_Invoice" prop="E_InvoiceBuyerEmail">
                            <template v-slot:label>
                                <div style="line-height: 1.5">買受人E-mail<br />(電子發票收件信箱)</div>
                            </template>
                            <el-input v-model.trim="form.E_InvoiceBuyerEmail" style="width: 350px" :maxlength="50" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item v-if="isEInvoiceEnabled && form.createE_Invoice" prop="E_InvoiceBuyerAddress" label="買受人地址">
                            <el-input v-model.trim="form.E_InvoiceBuyerAddress" style="width: 350px" :maxlength="100" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item v-if="isEInvoiceEnabled && form.createE_Invoice" prop="comment" label="發票開立備註">
                            <el-input v-model="form.comment" :autosize="{ minRows: 3 }" :maxlength="200" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="foO_PDAT" v-if="isFooPDatShow">
                            <template slot="label">
                                <template v-if="form.typ === 1"> INVOICE日期 </template>
                                <template v-else> <span v-if="enableInvoiceAuditFlow">預計</span>發票日期 </template>
                            </template>
                            <div>
                                <el-date-picker v-model="form.foO_PDAT" type="date" value-format="timestamp" placeholder="選擇日期" @change="handleFooDateChange"> </el-date-picker>
                                <el-alert v-if="form.typ !== 1 && newestDate" type="warning" size="small" :closable="false" class="small-alert"
                                    >最新發票日期：{{ newestDate | dateFormater("YYYY / MM / dd") }}</el-alert
                                >
                            </div>
                            <div>
                                <el-alert v-if="isFutureInvoiceDate" type="warning" size="small" :closable="false" class="future-invoice-alert">
                                    開立發票相關規定請至 財政部（<a href="https://law-out.mof.gov.tw/LawContent.aspx?id=FL006084" target="_blank"> 連結 </a>）查詢
                                </el-alert>
                            </div>
                        </el-form-item>
                        <div v-if="!enableInvoiceAuditFlow">
                            <el-form-item v-if="isFooInputShow" prop="foo" label="發票號碼">
                                <ahElInputInvoice v-model="form.foo" :key="form.foO_PDAT" :show-duplicate-hint="!enableInvoiceAuditFlow" :check-date="form.foO_PDAT" :ioo="form.ioo" />
                                <ah-receipt-input v-model="form.foo" :suggestion-only="true" :presets="fooPrefixs"></ah-receipt-input>
                            </el-form-item>
                            <el-form-item
                                v-else-if="form.typ === 1"
                                key="customFoo"
                                prop="foo"
                                label="自訂單號"
                                :rules="[
                                    {
                                        required: true,
                                        message: '請填寫自訂單號',
                                        trigger: 'blur',
                                    },
                                ]"
                            >
                                <el-input v-model="form.foo" :maxlength="20" show-word-limit style="width: 300px"></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item prop="pdat" label="預計收款日">
                            <el-date-picker v-model="form.pdat" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
                        </el-form-item>
                        <el-form-item label="審核流程預覽">
                            <div v-if="auditFlowSetting.invoiceAuditFlowSetting">
                                <ahAuditFlowViewer align="left" :b02Text="form.typ == 4 ? '填寫收入項目' : '開立'" :items="auditFlowSetting.invoiceAuditFlowSetting.settings[0].steps" size="small" />
                            </div>
                        </el-form-item>
                        <div v-if="!enableInvoiceAuditFlow">
                            <el-form-item prop="incomeItemNo" label="收入項目">
                                <ahSelectVariableStateItem
                                    :enableType="['invoice']"
                                    v-model="form.incomeItemNo"
                                    @onLoaded="onVaribleStateSelectorLoaded"
                                    @change="onVariableStateItemChange"
                                ></ahSelectVariableStateItem>
                            </el-form-item>
                            <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="accno" label="立帳科目">
                                <ahSuggestAccountingItemsSelector
                                    ref="ahSuggestAccountingItemsSelector"
                                    v-model="form.accno"
                                    @loaded="onAhSuggestAccountingItemsSelectorLoaded"
                                ></ahSuggestAccountingItemsSelector>
                            </el-form-item>
                            <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="clearanceAccno" label="沖帳科目">
                                <ah-select-accounting-setting v-model="form.clearanceAccno" width="200px" :allowedGroups="['assetsSettings', 'norSettings']" />
                            </el-form-item>
                        </div>
                        <el-form-item label="申請備註">
                            <el-input v-model="form.mem" type="textarea" :autosize="{ minRows: 3 }" :maxlength="200" :show-word-limit="true"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">發票金額</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="營業稅">
                            <el-select v-model="form.tax" placeholder="請選擇" @change="handleTaxChange">
                                <el-option label="應稅（5%）" :value="1" :disabled="form.typ === 1"></el-option>
                                <el-option label="零稅率" :value="2"></el-option>
                                <el-option label="免稅" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="amt" :label="form.tax == 1 ? '含稅總計' : '發票金額'">
                            <ah-el-select-cny v-model="form.cny" :disabled="form.isProject" @change="onChangeCny"></ah-el-select-cny>
                            <MoneyInput v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 4" style="margin-left: 6px; width: 240px" :disabled="form.isProject" @change="handleAmtChanged" />
                            <span v-if="form.cny != 'TWD'" style="border: 1px solid #ddd; color: #888; background-color: #fbfbfb; padding: 11px 15px; margin-left: 6px; border-radius: 5px">
                                <span>約當台幣：</span>
                                <Money :v="twdStatistic.amt" /> 元
                            </span>
                        </el-form-item>
                        <el-form-item v-if="form.cny != 'TWD'" label="匯率">
                            <MoneyInput v-model="form.rat" :precision="form.cny == 'TWD' ? 0 : 4" style="width: 100px" @change="autoFillEmptyInstallmentsAmt()" />
                        </el-form-item>
                        <el-form-item prop="" label="銷售額（未稅）" v-if="form.tax == 1">
                            <ah-el-select-cny v-model="form.cny" :disabled="true"></ah-el-select-cny>
                            <MoneyInput v-model="nonTaxAmt" :precision="form.cny == 'TWD' ? 0 : 4" style="margin-left: 6px; width: 240px" :disabled="form.isProject" @input="handleNonTaxAmtInput" />
                            <span v-if="form.cny != 'TWD'" style="border: 1px solid #ddd; color: #888; background-color: #fbfbfb; padding: 11px 15px; margin-left: 6px; border-radius: 5px">
                                <span>約當台幣：</span>
                                <Money :v="twdStatistic.nonTaxAmt" />
                                元
                            </span>
                        </el-form-item>
                        <el-form-item prop="" label="稅額" v-if="form.tax == 1">
                            <ah-el-select-cny v-model="form.cny" :disabled="true"></ah-el-select-cny>
                            <MoneyInput :value="tax" :precision="form.cny == 'TWD' ? 0 : 4" style="margin-left: 6px; width: 240px" :disabled="true" />
                            <span v-if="form.cny != 'TWD'" style="border: 1px solid #ddd; color: #888; background-color: #fbfbfb; padding: 11px 15px; margin-left: 6px; border-radius: 5px">
                                <span>約當台幣：</span>
                                <Money :v="twdStatistic.tax" /> 元
                            </span>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel" v-if="form.typ != 4">
                    <div class="panel-header small gray">
                        <div class="panel-title">發票項目</div>
                    </div>
                    <div class="panel-body">
                        <div style="text-align: right; margin-bottom: 20px">
                            <el-checkbox v-model="useTaxIncludedAmt" class="use-tax-included-checkbox" @change="autoFillEmptyInstallmentsAmt">以含稅單價輸入</el-checkbox>
                            <div v-if="useTaxIncludedAmt" class="use-tax-included-hint">實際以未稅金額計算發票總額，含稅單價僅供參考</div>
                        </div>
                        <!-- <el-checkbox v-model="useTaxIncludedAmt">使用含稅金額</el-checkbox> -->
                        <div class="invoice-item-table-area">
                            <el-table :data="form.invoiceItems" empty-text="無項目" show-summary :summary-method="invoiceItemsGetSummary" size="small" class="invoice-item-table">
                                <el-table-column prop="iteM_NAM" label="品名（必填)">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'invoiceItems.' + scope.$index + '.iteM_NAM'" :rules="rules.invoiceItemNam" label-width="0">
                                            <el-input v-model="scope.row.iteM_NAM" class="item-name" :maxlength="form.createE_Invoice ? 30 : 200" show-word-limit />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="qty" label="數量" width="75">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'invoiceItems.' + scope.$index + '.qty'" :rules="rules.invoiceItemQty" label-width="0">
                                            <el-input v-model.number="scope.row.qty" @keyup.native="handleItemQtyChange(scope.row)" :disabled="scope.row.iteM_NAM.trim() == ''" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unit" label="單位" width="85">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'invoiceItems.' + scope.$index + '.unit'" :rules="rules.invoiceItemUnit" label-width="0">
                                            <el-input v-model="scope.row.unit" :disabled="scope.row.iteM_NAM.trim() == ''" :maxlength="2" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="pri" label="未稅單價" width="150">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'invoiceItems.' + scope.$index + '.pri'" :rules="rules.invoiceItemPri" label-width="0">
                                            <el-tooltip effect="dark" content="請先輸入品名" placement="top" :manual="useTaxIncludedAmt || !scope.row.iteM_NAM.trim() == ''">
                                                <money-input
                                                    v-model="scope.row.pri"
                                                    :disabled="useTaxIncludedAmt || scope.row.iteM_NAM.trim() == ''"
                                                    :precision="form.cny == 'TWD' ? 2 : 4"
                                                    @change="handleItemNonTaxedPriChange(scope.row)"
                                                />
                                            </el-tooltip>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="useTaxIncludedAmt" prop="taxedPri" width="160">
                                    <template slot="header">
                                        <div style="color: #463cb2">含稅單價</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'invoiceItems.' + scope.$index + '.taxedPri'" :rules="rules.invoiceItemPri" label-width="0">
                                            <el-tooltip effect="dark" content="請先輸入品名" placement="top" :manual="!scope.row.iteM_NAM.trim() == ''">
                                                <money-input
                                                    v-model="scope.row.taxedPri"
                                                    :disabled="!useTaxIncludedAmt || scope.row.iteM_NAM.trim() == ''"
                                                    :precision="form.cny == 'TWD' ? 2 : 4"
                                                    @change="handleItemTaxedPriChange(scope.row)"
                                                />
                                            </el-tooltip>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="amt" label="金額（未稅）" width="160">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'invoiceItems.' + scope.$index + '.amt'" :rules="rules.invoiceItemAmt" label-width="0">
                                            <money-input v-model="scope.row.amt" :disabled="true" :precision="form.cny == 'TWD' ? 2 : 4" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="" width="80">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="0">
                                            <el-button v-if="!isQR()" size="mini" @click="removeInvoiceItem(scope.row)">刪除</el-button>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="invoiceItemTotalDeviation > 1">
                                <el-alert type="error" center :closable="false" show-icon class="item-total-error-alert">
                                    <div v-if="!this.useTaxIncludedAmt">「項目總金額(未稅)」需等於「發票未稅金額」</div>
                                    <div v-if="this.useTaxIncludedAmt">「項目總額 (含稅單價 * 數量)」需等於「發票金額(含稅)」</div>
                                </el-alert>
                            </div>
                            <div class="invoice-item-table-below-contents" style="margin-bottom: 25px">
                                <div class="note-text">平台計算的稅額、銷售額總計、總計等金額僅供參考。因各家稅務計算方式可能不同，請務必再次確認，如有誤差請自行調整。</div>
                                <el-button v-if="!isQR()" @click="addInvoiceItem" size="small" plain type="primary">新增項目</el-button>
                            </div>
                            <div v-if="(form.typ === 2 || form.typ === 3) && this.hasEInvoiceService && this.eInvoiceCmp === 'EZPay'" class="ah-warning-box">
                                <div class="title">ezPay電子發票注意事項</div>
                                <div class="content">
                                    <ul>
                                        <li>所有品名總字數須小於 30 - (項目個數) 個字。</li>
                                        <li>商品單位字數限中文 2 字或英數 6 字。</li>
                                        <li>所有金額皆須為整數</li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="(form.typ === 2 || form.typ === 3) && this.hasEInvoiceService && this.eInvoiceCmp === 'SunPay'" class="ah-warning-box">
                                <div class="title">紅陽電子發票注意事項</div>
                                <div class="content">
                                    <ul>
                                        <li>最多接受 10 項商品，每項商品名稱最多 100 個字元，不可有特殊字元。包含：*'&lt;&gt;[]"，如商品數量過多或金額有負值，建議整合為單一商品名稱傳送。</li>
                                        <li>紅陽平台列印 B2B 格式發票時，不會顯示發票開立備註。如需填寫發票備註，請填寫於品名。</li>
                                        <li>所有金額皆須為整數</li>
                                    </ul>
                                </div>
                            </div>
                            <el-alert v-if="hasEInvoiceService && hasFloatInItemPrice" type="warning" :closable="false" style="margin-top: 10px" show-icon
                                >注意：此發票項目金額中含有小數點，將無法使用電子發票開立。</el-alert
                            >
                        </div>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">檢附文件</div>
                    </div>
                    <div class="panel-body">
                        <div style="margin-left: 200px">
                            <InvoiceFilesView ref="InvoiceFilesView" :form="form" create-mode @change="form.invoiceFiles = $event" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="ah-container" style="display: flex; justify-content: space-between">
                <div>
                    <el-button type="danger" plain @click="handleVoidBtnClick" v-if="form.stF_SNO == this.$store.getters['account/userSno'] && !isQR()" icon="el-icon-delete">撤銷發票申請</el-button>
                </div>
                <div>
                    <el-button @click="handleCancel" icon="el-icon-close">{{ form.sno ? "取消編輯" : "取消申請" }}</el-button>
                    <el-button type="primary" class="primary-action" @click="submit" :loading="isSubmitting" icon="el-icon-check">送出</el-button>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import accounting from 'accounting-js';
import { invoiceType } from '@/assets/commonData/options';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahReceiptInput from '@/components/ui/ahReceiptInput.vue';
import ahSelectProject from '@/components/ui/ahSelectProject.vue';
import ahSelectClient from '@/components/ui/ahSelectClient.vue';
import ahProjectCard from '@/components/ui/ahProjectCard.vue';
import ahAuditFlowViewer from '@/components/ui/ahAuditFlowViewer.vue';
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';
import InvoiceFilesView from '@/components/dashboard/Invoice/InvoiceDetailDialog/InvoiceFilesView.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';

export default {
    components: {
        // ahTip
        ahElSelectCny,
        ahSelectVariableStateItem,
        ahReceiptInput,
        ahSelectProject,
        ahSelectClient,
        ahAuditFlowViewer,
        ahProjectCard,
        ahElInputInvoice,
        InvoiceFilesView,
        ahSuggestAccountingItemsSelector,
        ahSelectAccountingSetting,
    },
    computed: {
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },
        isFutureInvoiceDate() {
            if (this.enableInvoiceAuditFlow) return false;
            const TODAY = moment().startOf('day');
            return moment(this.form.foO_PDAT).isAfter(TODAY);
        },
        // 發票日期設定
        invoiceDatePickerOptions() {
            const { newestDate } = this;
            return {
                disabledDate(time) {
                    if (newestDate) return time.getTime() < newestDate;
                    return true;
                },
            };
        },

        // 發票類型
        invoiceTypeOptions() {
            return invoiceType.filter((x) => x.key !== null);
        },

        // 發票項目總金額
        invoiceItemTotal() {
            let sum = 0;
            for (let i = 0; i < this.form.invoiceItems.length; i += 1) {
                sum += Number(this.form.invoiceItems[i].amt);
            }
            return sum;
        },

        // 項目金額加總 與 發票金額 差額
        invoiceItemTotalDeviation() {
            // 以未稅價輸入（預設）
            // 項目未稅金額加總 - 發票未稅金額 要誤差小於1
            if (!this.useTaxIncludedAmt) {
                return Math.abs(this.invoiceItemTotal - this.nonTaxAmt);
            }
            // 以含稅價輸入（使用者勾選）
            // 項目含稅金額加總 - 發票含稅金額 要誤差小於1
            if (this.useTaxIncludedAmt) {
                const totalItemsTaxedAmt = this.form.invoiceItems.reduce((sum, item) => sum + item.taxedPri * item.qty, 0);
                return Math.abs(this.form.amt - totalItemsTaxedAmt);
            }
            return 0;
        },

        // 有勾選的專案分期總和
        projectInstallmentTotal() {
            let sum = 0;
            for (let i = 0; i < this.selectedProjects.length; i += 1) {
                for (let j = 0; j < this.selectedProjects[i].installments.length; j += 1) {
                    const installment = this.selectedProjects[i].installments[j];
                    if (installment.checked) sum += installment.amt;
                }
            }
            return sum;
        },

        // 稅金
        tax() {
            if (this.form.tax === 1) {
                return this.form.cny === 'TWD' ? Math.round((this.form.amt / 1.05) * 0.05) : Math.round((this.form.amt / 1.05) * 0.05 * 10000) / 10000;
            }
            return 0;
        },

        // 是否可選擇發票幣別
        isCnyDisabled() {
            return this.form.isProject || this.form.typ === 2 || this.form.typ === 3;
        },

        isFooInputShow() {
            return !(this.form.typ === 1 || this.form.typ === 4) && !this.form.createE_Invoice;
        },

        isFooPDatShow() {
            if (this.enableInvoiceAuditFlow) return this.form.typ !== 4;
            if (this.form.createE_Invoice) return false;
            return this.form.typ !== 4;
        },

        isEInvoiceEnabled() {
            if (!this.hasEInvoiceService) return false;
            if (this.enableInvoiceAuditFlow) return false;
            return this.form.typ === 3;
        },

        hasEInvoiceService() {
            return this.$store.getters['menu/companyInfo'].eInvoice;
        },

        eInvoiceCmp() {
            return this.$store.getters['menu/companyInfo'].eInvoiceInfo.platform;
        },

        twdStatistic() {
            const amt = Math.round(this.form.amt * this.form.rat);
            const tax = Math.round((amt / 1.05) * 0.05);
            const nonTaxAmt = amt - tax;
            return { amt, tax, nonTaxAmt };
        },

        hasFloatInItemPrice() {
            for (let i = 0; i < this.form.invoiceItems.length; i += 1) {
                if (this.form.invoiceItems[i].pri.toString().indexOf('.') !== -1) {
                    return true;
                }
            }
            return false;
        },
    },
    data() {
        // 自訂驗證 - 專案
        const validateProject = (rule, value, callback) => {
            if (this.form.isProject && this.form.projects.length <= 0) {
                callback(new Error('請選擇專案'));
            } else {
                callback();
            }
        };
        const invoiceValidate = (rule, value, callback) => {
            if (!value) callback(new Error('請填寫發票號碼'));
            else if (value.length < 10) callback(new Error('請輸入完整發票號碼'));
            callback();
        };

        return {
            isAhSuggestAccountingItemsSelectorShow: true,

            isFetchingProjectList: false,
            isSubmitting: false,
            isLoadingProjectSelect: false,
            isShowProjectSelect: true,
            selectedProjectSno: null,
            enableInvoiceAuditFlow: true,
            selectedProjects: [],
            incomeList: [], // 收入項目
            subIncomeList: [], // 收入項目(次)
            newestDate: null, // 最新發票日期
            fooPrefixs: [],
            nonTaxAmt: 0,
            suggestAccountItems: [],
            useTaxIncludedAmt: false, // 只 UI 使用
            form: {
                typ: 3, // 1:invoice, 2:二聯式, 3:三聯式
                createE_Invoice: false, // 【簡易流程】是否使用平台開立電子發票
                vdR_SNO: null,
                E_InvoiceBuyerEmail: null,
                E_InvoiceBuyerAddress: null,
                tax: 1,
                rat: 1,
                cny: 'TWD',
                pdat: null,
                incomeItemNo: null,
                accno: null,
                clearanceAccno: null,
                description: '',
                projects: [],
                invoiceItems: [],
                foo: null,
                foO_PDAT: null,
                isProject: true, // 只 UI 使用
                bsn: '', // 只 UI 使用
                amt: 0,
                comment: null,
                invoiceFiles: [],
            },
            auditProgress: null,
            auditFlowSetting: {}, // 設定裡的審核流程設定
            projectList: [],
            currencyList: [],
            projectInvoiceItemsAmtAdv: 0,
            rules: {
                vdR_SNO: [
                    {
                        required: true,
                        message: '請選擇客戶',
                        trigger: 'change',
                    },
                ],
                description: [
                    {
                        required: true,
                        message: '請填寫摘要',
                        trigger: ['blur', 'change'],
                    },
                ],
                foo: [
                    {
                        required: true,
                        validator: invoiceValidate,
                        trigger: 'blur',
                    },
                ],
                amt: [
                    {
                        required: true,
                        message: '請填寫發票含稅總計',
                        trigger: 'blur',
                    },
                ],
                bsn: [
                    {
                        required: true,
                        message: '三聯式發票必填統編，請至客戶資料填寫統編',
                        trigger: 'change',
                    },
                ],
                foO_PDAT: [
                    {
                        required: true,
                        message: '請選擇發票日期',
                        trigger: 'blur',
                    },
                ],
                pdat: [
                    {
                        required: true,
                        message: '請選擇預計收款日期',
                        trigger: 'change',
                    },
                ],
                incomeItemNo: [
                    {
                        required: true,
                        message: '請選擇收入項目',
                        trigger: 'change',
                    },
                ],
                project: [
                    {
                        validator: validateProject,
                        trigger: 'change',
                    },
                ],
                invoiceItemNam: [
                    {
                        required: true,
                        message: '請填寫品名',
                        trigger: 'blur',
                    },
                ],
                invoiceItemQty: [
                    {
                        required: true,
                        message: '請填數量',
                        trigger: 'blur',
                    },
                ],
                invoiceItemUnit: [
                    {
                        required: true,
                        message: '請填單位',
                        trigger: 'blur',
                    },
                ],
                invoiceItemPri: [
                    {
                        required: true,
                        message: '請填寫單價',
                        trigger: 'blur',
                    },
                ],
                invoiceItemAmt: [
                    {
                        required: true,
                        message: '請填寫金額',
                        trigger: 'blur',
                    },
                ],
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
        };
    },
    async mounted() {
        await this.$store.dispatch('accounting/updateAccountingSettings');
        this.isLoadingProjectSelect = true;
        await this.fetchAuditFlow();
        this.fetchCurrencyOptions();
        this.fetchNewestInvoiceDate();

        const { sno } = this.$route.params;

        if (sno) {
            // 編輯
            this.isShowProjectSelect = false;
            // 載入專案資料
            this.fetchInvoiceData(sno);
        } else {
            if (this.form.invoiceItems.length === 0) {
                // 新增
                // add first empty item
                this.addInvoiceItem();
                this.isAhSuggestAccountingItemsSelectorShow = false;
            }
            if (!this.enableInvoiceAuditFlow) this.form.clearanceAccno = '1130';
        }

        // 使用 cache 資料（客戶新增後返回）
        if (Number(this.$route.query.cache) === 1) {
            await this.loadFromCache();
        }
        this.isLoadingProjectSelect = false;

        if (this.$route.query.vendorsno != null) {
            this.form.vdR_SNO = parseInt(this.$route.query.vendorsno, 10);
            this.handleClientSelectChange(parseInt(this.$route.query.vendorsno, 10));
        }
        if (this.$route.query.projectsno != null) {
            this.addSelectedProjectBySno(parseInt(this.$route.query.projectsno, 10));
        }

        this.$refs.form.clearValidate();
    },
    watch: {
        projectInstallmentTotal() {
            // 自動填入未稅金額到第一項目
            if (!this.form.sno && this.form.invoiceItems.length === 1 && this.form.invoiceItems[0].qty === 1 && this.form.invoiceItems[0].iteM_NAM === '') {
                const amt = this.projectInstallmentTotal - this.tax;
                this.form.invoiceItems[0].qty = 1;
                this.form.invoiceItems[0].pri = amt;
                this.form.invoiceItems[0].amt = amt;
            }
        },
    },
    methods: {
        handleFooDateChange() {
            if (this.form.foO_PDAT) this.fetchSerialNumber(this.form.foO_PDAT);
        },
        fetchSerialNumber(datetime) {
            this.$api({
                url: 'InvoiceManagemnetPage/GetPrefix',
                params: { DAT: datetime },
                method: 'GET',
            }).then((resp) => {
                if (resp.data.prefixs.length > 0) {
                    this.fooPrefixs = _.filter(resp.data.prefixs, ['prefixType', 1]);
                    // this.form.foo = resp.data.prefixs[resp.data.prefixs.length - 1];
                }
            });
        },
        handleNonTaxAmtInput() {
            const tax = this.form.cny === 'TWD' ? Math.round(this.nonTaxAmt * 0.05) : Math.round(this.nonTaxAmt * 0.05 * 10000) / 10000;
            this.form.amt = this.form.cny === 'TWD' ? Math.round(this.nonTaxAmt + tax) : Math.round((this.nonTaxAmt + tax) * 10000) / 10000;
            this.autoFillEmptyInstallmentsAmt();
        },
        handleAmtChanged() {
            this.autoFillEmptyInstallmentsAmt();
        },
        handleTaxChange() {
            this.autoFillEmptyInstallmentsAmt();
        },
        handleAddProjectBtnClick() {
            this.isShowProjectSelect = true;
            setTimeout(() => {
                this.$refs.projectSelect.$children[0].focus();
            }, 1);
        },

        saveToCache() {
            console.log('invoice cached');
            const cachedForm = this.form;
            cachedForm.projects = [...this.selectedProjects];
            localStorage.setItem('invoice-cache', JSON.stringify(cachedForm));
        },
        async loadFromCache() {
            const rowdata = localStorage.getItem('invoice-cache');
            if (rowdata) {
                console.log(JSON.parse(rowdata));
                await this.applyFormData(JSON.parse(rowdata));
            }
            if (!rowdata) {
                console.log('no cached data found.');
            }
        },
        async applyFormData(targetForm) {
            const { vendorsno, projectsno } = this.$route.query;
            let projects = [];
            _.forEach(targetForm, (value, key) => {
                if (projectsno && key === 'projects') return;
                if (vendorsno && key === 'bsn') return;

                if (key === 'projects') projects = [...value];
                this.form[key] = value;
            });

            await this.fetchProject(projects);
        },
        async fetchProject(projects) {
            if (!projects.length) return;

            this.isShowProjectSelect = false;

            for (let i = 0; i < projects.length; i += 1) {
                const { sno } = projects[i];
                // eslint-disable-next-line no-await-in-loop
                await this.addSelectedProjectBySno(parseInt(sno, 10));
            }
            projects.forEach((project, index) => {
                const found = _.find(projects, ['sno', this.selectedProjects[index].sno]);
                this.selectedProjects[index].installments = [...found.installments];
            });
            this.updateAutoDescription();
        },

        onAddProjectBtnClick() {
            this.saveToCache();
            this.$router.push({
                name: 'project-add',
                query: {
                    from: 'invoice-add',
                },
            });
        },

        onAddVenderBtnClick() {
            this.saveToCache();
            this.$router.push({
                name: 'vendor-add',
                query: {
                    from: 'invoice-add',
                },
            });
        },

        autoFillEmptyInstallmentsAmt() {
            const amtWithOutTax = this.form.cny === 'TWD' ? Math.round(this.form.amt - this.tax) : Math.round((this.form.amt - this.tax) * 10000) / 10000;
            this.nonTaxAmt = amtWithOutTax;
            if (this.form.invoiceItems.length > 0) {
                // 區分有手動輸入的分期金額(用品名判斷)
                const usedItems = [];
                const noneUsedItems = [];
                let usedItemsNonTaxedAmt = 0;
                let usedItemsTaxedAmt = 0;
                for (let i = 0; i < this.form.invoiceItems.length; i += 1) {
                    if (this.form.invoiceItems[i].iteM_NAM != null && this.form.invoiceItems[i].iteM_NAM !== '') {
                        usedItems.push(this.form.invoiceItems[i]);
                        usedItemsNonTaxedAmt += this.form.invoiceItems[i].amt;
                        usedItemsTaxedAmt += this.form.invoiceItems[i].taxedAmt;
                    } else {
                        noneUsedItems.push(this.form.invoiceItems[i]);
                    }
                }

                // 將總金額分配到剩餘分期
                const remainNonTaxedAmt = amtWithOutTax - usedItemsNonTaxedAmt;
                const remainTaxedAmt = this.form.amt - usedItemsTaxedAmt;
                if (noneUsedItems.length > 0 && remainNonTaxedAmt > 0) {
                    let eachItemNonTaxedAmt;
                    let eachItemTaxedAmt;

                    if (this.form.cny === 'TWD' && !this.useTaxIncludedAmt) {
                        eachItemNonTaxedAmt = Math.floor(remainNonTaxedAmt / noneUsedItems.length);
                        eachItemTaxedAmt = Math.floor(remainTaxedAmt / noneUsedItems.length);
                    } else {
                        eachItemNonTaxedAmt = Math.round((remainNonTaxedAmt / noneUsedItems.length) * 10000) / 10000;
                        eachItemTaxedAmt = Math.round((remainTaxedAmt / noneUsedItems.length) * 10000) / 10000;
                    }

                    // 只有一個分期
                    if (noneUsedItems.length === 1) {
                        noneUsedItems[0].qty = 1;
                        noneUsedItems[0].pri = eachItemNonTaxedAmt;
                        noneUsedItems[0].amt = eachItemNonTaxedAmt;
                        noneUsedItems[0].taxedPri = eachItemTaxedAmt;
                        noneUsedItems[0].taxedAmt = eachItemTaxedAmt;
                    }

                    // 多個分期，避免小數點問題，最後一個另外處理
                    if (noneUsedItems.length > 1) {
                        let filledNonTaxedAmt = 0;
                        let filledTaxedAmt = 0;
                        for (let j = 0; j < noneUsedItems.length - 1; j += 1) {
                            noneUsedItems[j].qty = 1;
                            noneUsedItems[j].pri = eachItemNonTaxedAmt;
                            noneUsedItems[j].amt = eachItemNonTaxedAmt;
                            noneUsedItems[j].taxedPri = eachItemTaxedAmt;
                            noneUsedItems[j].taxedAmt = eachItemTaxedAmt;
                            filledNonTaxedAmt += eachItemNonTaxedAmt;
                            filledTaxedAmt += eachItemTaxedAmt;
                        }

                        const lastIndex = noneUsedItems.length - 1;
                        let lastNonTaxedAmt;
                        let lastTaxedAmt;

                        if (this.form.cny === 'TWD' && !this.useTaxIncludedAmt) {
                            lastNonTaxedAmt = Math.round(remainNonTaxedAmt - filledNonTaxedAmt);
                            lastTaxedAmt = Math.round(remainTaxedAmt - filledTaxedAmt);
                        } else {
                            lastNonTaxedAmt = Math.round((remainNonTaxedAmt - filledNonTaxedAmt) * 10000) / 10000;
                            lastTaxedAmt = Math.round((remainTaxedAmt - filledTaxedAmt) * 10000) / 10000;
                        }

                        noneUsedItems[lastIndex].qty = 1;
                        noneUsedItems[lastIndex].pri = lastNonTaxedAmt;
                        noneUsedItems[lastIndex].amt = lastNonTaxedAmt;
                        noneUsedItems[lastIndex].taxedPri = lastTaxedAmt;
                        noneUsedItems[lastIndex].taxedAmt = lastTaxedAmt;
                    }
                }
            }
        },

        handleTypeChange() {
            // Invoice 自動選擇零稅率、美金
            if (this.form.typ === 1) {
                this.form.tax = 2;
            }
            // 核銷 （預設選專案）
            if (this.form.typ === 4) {
                this.form.tax = 3;
            }

            if (this.form.typ === 2 || this.form.typ === 3) {
                this.form.tax = 1;
                if (!this.form.isProject) this.form.cny = 'TWD';
            }
            this.$refs.form.clearValidate();
            this.autoFillEmptyInstallmentsAmt();
        },

        handleItemQtyChange(item) {
            // eslint-disable-next-line no-param-reassign
            item.amt = item.qty * item.pri;
            // eslint-disable-next-line no-param-reassign
            item.taxedAmt = item.qty * item.taxedPri;
            this.autoFillEmptyInstallmentsAmt();
        },

        handleItemNonTaxedPriChange(item) {
            // eslint-disable-next-line no-param-reassign
            item.taxedPri = this.form.cny === 'TWD' ? Math.round(item.pri * 1.05) : Math.round(item.pri * 1.05 * 10000) / 10000;
            // eslint-disable-next-line no-param-reassign
            item.amt = item.qty * item.pri;
            // eslint-disable-next-line no-param-reassign
            item.taxedAmt = item.qty * item.taxedPri;
            this.autoFillEmptyInstallmentsAmt();
        },

        handleItemTaxedPriChange(item) {
            // 未稅金額
            // eslint-disable-next-line no-param-reassign
            item.pri = Math.round((item.taxedPri / 1.05) * 100) / 100;
            if (this.form.cny === 'TWD') {
                // eslint-disable-next-line no-param-reassign
                item.pri = Math.floor(item.pri);
            }
            // eslint-disable-next-line no-param-reassign
            item.amt = item.qty * item.pri;
            // eslint-disable-next-line no-param-reassign
            item.taxedAmt = item.qty * item.taxedPri;
            this.autoFillEmptyInstallmentsAmt();
        },

        handleCancel() {
            this.$router.push({ name: 'invoice' });
        },

        // 當專案下拉選取
        handleProjectSelectChange(projectSno) {
            // 檢查是否為原專案
            const existOriginalProject = _.chain(this.form.projects)
                .find((p) => p.projectSno === projectSno)
                .get('installments')
                .map((o) => o.sno)
                .value();
            // 檢查是否已加入
            const existProject = this.selectedProjects.find((p) => p.sno === projectSno);
            if (existProject == null) {
                // 載入專案細節資料 ,自動選取專案客戶
                this.addSelectedProjectBySno(projectSno, existOriginalProject);
            }

            // 清除專案搜尋輸入
            this.selectedProjectSno = null;
            this.isShowProjectSelect = false;
        },
        handleProjectSelectBlur() {},

        async addSelectedProjectBySno(projectSno, preCheckInstallmentSnoList = []) {
            // 載入專案詳細資料，加入 selectedProjects 供顯示
            const resp = await this.$api({
                url: 'InvoiceManagemnetPage/GetProjectDetail',
                params: { Sno: projectSno },
                method: 'GET',
            });

            const p = resp.data.item;

            // 判斷是否與現有專案幣別衝突
            if (this.selectedProjects.length > 0) {
                const currCny = this.selectedProjects[0].cny;
                if (currCny !== p.cny) {
                    // eslint-disable-next-line no-alert
                    alert('與此發票的其他專案幣別不符，無法增加。');
                    return;
                }
            }

            // 新增模式下，自動選取專案客戶
            if (this.form.sno == null) {
                this.form.vdR_SNO = p.vdR_SNO;
                this.form.cny = p.cny;
                this.form.rat = this.getCnyRat(p.cny);
                this.handleClientSelectChange(p.vdR_SNO);
            }

            // 勾選分期（視preCheckInstallmentSnoList 參數)
            for (let j = 0; j < p.installments.length; j += 1) {
                p.installments[j].checked = false;

                // 預勾選 （編輯模式，是已勾選的分期）
                if (preCheckInstallmentSnoList && preCheckInstallmentSnoList.length > 0) {
                    // 未審核的分期
                    if (p.installments[j].sts === 0) {
                        if (preCheckInstallmentSnoList.includes(p.installments[j].sno)) {
                            p.installments[j].checked = true;
                        }
                    }
                }
            }

            // 加入至清單
            this.selectedProjects.push(p);

            // 自動摘要（新增模式）
            if (this.form.sno == null) {
                this.updateAutoDescription();
            }

            // 待補找不到處理
        },

        handleClientSelectChange(clientSno) {
            if (!clientSno) return;
            if (this.isLoadingProjectSelect) return;
            // 填入客戶統編
            this.$api({
                url: 'VendorManagementPage/GetVendorInfo',
                params: { SNO: clientSno },
                method: 'GET',
            }).then((resp) => {
                this.form.bsn = resp.data.item.bsn;
                if (this.isEInvoiceEnabled) {
                    this.form.E_InvoiceBuyerEmail = _.first(resp.data.item.vendorContacts)?.eml;
                    this.form.E_InvoiceBuyerAddress = resp.data.item.adr;
                }
            });
            // 待補找不到處理
        },

        // 當專案分期勾選變更
        handleProjectInstallmentCheckChange() {
            console.log('CHC');
            this.form.amt = this.projectInstallmentTotal;
            this.autoFillEmptyInstallmentsAmt();
            if (this.form.sno == null) {
                this.updateAutoDescription();
            }
        },

        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        updateAutoDescription() {
            const projects = this.getSelectedProjectWithInstallment();
            if (projects.length > 0) {
                const projectList = [];
                const projectCustomnumberList = [];
                projects.forEach((project) => {
                    // 取得分期編號陣列
                    const installNames = [];
                    project.installments.forEach((ins) => {
                        installNames.push(ins.stG_NO);
                    });

                    // 合成單一專案摘要
                    projectList.push(`${project.projectName}-第${installNames.join('、')}期`);
                    if (project.customnumber) {
                        projectCustomnumberList.push(project.customnumber);
                    }
                });

                const PCN = projectCustomnumberList.join('、');
                const PI = projectList.join('、');
                // 合成全部摘要
                this.form.description = `${PCN}${PCN ? '_' : ''}${PI}`;
            } else {
                this.form.description = '';
            }
        },

        // 取得已勾選的專案＆分期
        getSelectedProjectWithInstallment() {
            const projects = [];

            for (let i = 0; i < this.selectedProjects.length; i += 1) {
                const p = this.selectedProjects[i];

                // 格式化專案資料 for api
                const project = {
                    ...p,
                    projectSno: p.sno,
                    invoiceSno: this.form.sno,
                    projectName: p.nam,
                    installments: [],
                };

                // 裝入有打勾的分期
                for (let j = 0; j < p.installments.length; j += 1) {
                    const inst = p.installments[j];
                    if (inst.checked) {
                        project.installments.push({
                            sno: inst.sno,
                            mno: inst.mno,
                            fsno: inst.fsno,
                            poo: inst.poo,
                            stG_NO: inst.stG_NO,
                            amt: inst.amt,
                            cny: this.form.cny,
                            delete: false,
                        });
                    }
                }

                // 如果有分期就加入
                if (project.installments.length > 0) projects.push(project);
            }

            return projects;
        },

        // 專案發票 / 非專案 切換
        handleIsProjectChange() {},

        // 載入設定裡的請款流程
        async fetchAuditFlow() {
            const resp = await this.$api({
                url: '/Tool/GetAuditFlowTemplates',
                method: 'GET',
            });

            this.auditFlowSetting = resp.data;
            this.enableInvoiceAuditFlow = resp.data.invoiceAuditFlowSetting.isEnable;
        },

        // 取得最後發票日期
        fetchNewestInvoiceDate() {
            this.$api({
                url: '/InvoiceManagemnetPage/GetNewestInvoceFOO_DATE',
                method: 'GET',
            }).then((resp) => {
                this.newestDate = resp.data.newestDate;
                console.log('invoice newest date: ', new Date(resp.data.newestDate));
            });
        },

        // 載入幣別列表
        fetchCurrencyOptions() {
            this.$api({
                url: '/Tool/GetCurrencyOptions',
                method: 'GET',
            }).then((resp) => {
                if (resp.data.options && resp.data.options.length > 0) {
                    this.currencyList = resp.data.options;
                } else {
                    this.currencyList = [];
                    this.form.cny = 'TWD';
                }
            });
        },

        // 載入已有的專案資料 （編輯模式）
        fetchInvoiceData(sno) {
            this.$api({
                url: `/InvoiceManagemnetPage/GetInvoiceInfo?Sno=${sno}`,
                method: 'GET',
            }).then((resp) => {
                const form = resp.data.item.item;
                form.isProject = false;

                this.form = form;
                console.log('invoice: ', resp.data);

                if (this.statementOptions.cInElseSettings) {
                    this.$nextTick(() => {
                        this.$refs.ahSuggestAccountingItemsSelector.init(this.form.incomeItemNo);
                    });
                }

                // 依amt自動計算未稅金額
                this.nonTaxAmt = this.form.amt - this.tax;

                // 依invoiceItems計算含稅金額
                this.form.invoiceItems.forEach((item) => {
                    // eslint-disable-next-line no-param-reassign
                    item.taxedPri = item.pri * 1.05;
                    // eslint-disable-next-line no-param-reassign
                    item.taxedAmt = item.amt * 1.05;
                });

                // 審核進度資料（取得退件說明）
                this.auditProgress = resp.data.item.auditProgress;

                // 由是否有專案資料切換 專案/非專案發票
                this.form.isProject = this.form.projects.length > 0;

                // 專案
                if (this.form.projects.length > 0) {
                    this.form.amt = 0;
                    // this.setExistsProjectsToSelected(this.form.vdR_SNO, this.form.projects)
                    // 逐一載入專案資料
                    for (let p = 0; p < this.form.projects.length; p += 1) {
                        const project = this.form.projects[p];

                        // 將已勾選的分期sno 轉為陣列
                        const checkedInstSnoList = [];
                        for (let j = 0; j < project.installments.length; j += 1) {
                            checkedInstSnoList.push(project.installments[j].sno);
                        }

                        // 載入專案
                        this.addSelectedProjectBySno(this.form.projects[p].projectSno, checkedInstSnoList);
                        // 計算發票金額
                        project.installments.forEach((installment) => {
                            this.form.amt += installment.amt;
                        });
                    }

                    // 依amt自動計算未稅金額
                    this.nonTaxAmt = this.form.amt - this.tax;
                }

                // 清空 invoiceItem 的 invoiceSno，都當作新的項目，避免沒儲存
                for (let i = 0; i < this.form.invoiceItems.length; i += 1) {
                    delete this.form.invoiceItems[i].invoiceSno;
                }
            });
        },

        // async setExistsProjectsToSelected(vdrSno, existProjects) {
        //     // 等待載入該客戶的專案列表
        //     await this.$api({
        //         url: `/InvoiceManagemnetPage/GetProjectList?VDR_SNO=${vdrSno}`,
        //         method: 'GET',
        //         data: { PageNum: 1, PageSize: 999 },
        //     }).then((resp) => {
        //         this.projectList = resp.data.items;
        //     });

        //     // 將存在的的專案製作為顯示的專案資料
        //     for (let p = 0; p < existProjects.length; p += 1) {
        //         const estp = existProjects[p];

        //         // 紀錄已勾選的分期
        //         const existInstSnoList = [];
        //         for (let j = 0; j < estp.installments.length; j += 1) {
        //             existInstSnoList.push(estp.installments[j].sno);
        //         }

        //         // 產生顯示專案
        //         this.addSelectedProject(estp.projectSno, existInstSnoList);
        //     }
        // },

        // 加入專案
        addSelectedProject(projectSno, preCheckInstallmentSnoList = []) {
            // 從已載入的專案列表中取得並複製出來
            const projectData = this.projectList.find((p) => p.sno === projectSno);

            if (projectData) {
                const p = JSON.parse(JSON.stringify(projectData));

                // 判斷是否與以有專案幣別衝突
                if (this.selectedProjects.length > 0) {
                    if (this.form.cny !== projectData.cny) {
                        this.$message({
                            showClose: true,
                            type: 'error',
                            message: '與該發票中已有專案幣別不符，無法加入。',
                        });
                        return;
                    }
                }

                // 加入分期選取狀態參數
                for (let j = 0; j < p.installments.length; j += 1) {
                    p.installments[j].checked = false;

                    // 預勾選 （編輯模式，是已勾選的分期）
                    if (preCheckInstallmentSnoList && preCheckInstallmentSnoList.length > 0) {
                        // 未審核的分期
                        if (p.installments[j].sts === 0) {
                            if (preCheckInstallmentSnoList.includes(p.installments[j].sno)) {
                                p.installments[j].checked = true;
                            }
                        }
                    }
                }
                this.selectedProjects.push(p);

                // 幣別
                this.form.cny = projectData.cny;
            } else {
                this.$message({
                    showClose: true,
                    type: 'error',
                    message: '無法找到該專案資料',
                });
            }
        },

        // 移除專案
        removeDisplayProject(sno) {
            this.selectedProjects = this.selectedProjects.filter((x) => x.sno !== sno);
            this.form.amt = this.projectInstallmentTotal;
        },

        resetForm() {
            this.form = {
                typ: 3,
                tax: 1,
                cny: 'TWD',
                incomeItemNo: null,
                projects: [],
                invoiceItems: [],
                foo: null,
                foO_PDAT: null,
                isProject: false, // 只 UI 使用
                bsn: '', // 只 UI 使用
                amt: 0,
            };
            this.$refs.form.clearValidate();
            this.$refs.form.resetFields();
            this.addInvoiceItem();
        },

        // 增加發票項目
        addInvoiceItem() {
            this.form.invoiceItems.push({
                iteM_NAM: '',
                qty: 1,
                pri: 0,
                taxedPri: 0, // 僅前端使用
                amt: 0,
                taxedAmt: 0, // 僅前端使用
                cny: 'TWD',
                unit: '式',
                key: Date.now(), // 僅前端使用
            });
            this.autoFillEmptyInstallmentsAmt();
        },

        // 刪除發票項目
        removeInvoiceItem(item) {
            this.form.invoiceItems.splice(this.form.invoiceItems.indexOf(item), 1);
            this.autoFillEmptyInstallmentsAmt();
        },

        // 送出表單
        submit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    const code = this.getInvoiceValidateCode(this.form);

                    try {
                        if ((this.form.typ === 2 || this.form.typ === 3) && this.form.foo && !code) {
                            await this.$confirm('您輸入的發票號碼不存在於發票日期所屬營業稅申報期別，確定要儲存嗎？', {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }

                        // 檢查電子發票不可開有小數點的項目
                        if (this.form.createE_Invoice && this.hasFloatInItemPrice) {
                            this.$message({
                                showClose: true,
                                type: 'error',
                                message: '發票項目中有小數點，無法以電子發票開立。',
                            });
                            return;
                        }

                        if (!this.form.isProject) {
                            // 非專案發票，在存檔時順手將專案紀錄清空
                            this.form.projects = [];
                        } else {
                            // 專案發票，自動使用專案幣別
                            // 產生已勾選的專案分期
                            this.form.projects = this.getSelectedProjectWithInstallment();

                            // 沒有專案
                            if (this.form.projects.length === 0) {
                                this.$message({
                                    showClose: true,
                                    type: 'error',
                                    message: '請至少選擇一個專案分期',
                                });
                                return;
                            }
                        }

                        // 核銷發票（無項目）
                        if (this.form.typ === 4) {
                            this.form.invoiceItems = [];
                            // 發票日等於收款日
                            this.form.foO_PDAT = this.form.pdat;
                            this.form.foO_DAT = this.form.pdat;
                        }

                        // 一般發票（有項目）
                        if (this.form.typ !== 4) {
                            // 項目未稅金額加總 - 發票未稅金額 要誤差小於1
                            if (this.invoiceItemTotalDeviation > 1) {
                                this.$message({
                                    showClose: true,
                                    type: 'error',
                                    message: '發票項目總額需等於發票總額',
                                });
                                return;
                            }

                            // 設定發票項目的幣別
                            for (let i = 0; i < this.form.invoiceItems.length; i += 1) {
                                this.form.invoiceItems[i].cny = this.form.cny;
                            }
                        }

                        // 總金額不可為0
                        if (this.form.amt <= 0) {
                            this.$message({
                                showClose: true,
                                type: 'error',
                                message: '發票金額不可為零',
                            });
                            return;
                        }

                        // 簡易流程：
                        if (!this.enableInvoiceAuditFlow) {
                            // 發票日期 ＝ 發票開立日期
                            this.form.foO_DAT = this.form.foO_PDAT;
                            // 格式代號
                            this.form.code = code;

                            // 核銷發票：收款日 = 發票日
                            if (this.form.typ === 4) {
                                this.form.foO_PDAT = this.form.pdat;
                                this.form.foO_DAT = this.form.pdat;
                                this.form.foo = null;
                                this.form.code = undefined;
                            }
                        }

                        console.log('invoice form: ', this.form);

                        // 送出
                        this.isSubmitting = true;
                        await this.$refs.InvoiceFilesView.executeDeleteFiles();
                        await this.$api({
                            url: '/InvoiceManagemnetPage/UpsertInvoice',
                            method: 'POST',
                            data: { ...this.form, appliedRat: this.form.rat },
                        });

                        this.$router.push({ name: 'invoice' });
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isSubmitting = false;
                    }
                } else {
                    this.scrollViewToError();
                }
            });
        },

        handleVoidBtnClick() {
            this.$confirm('確認要撤銷此發票？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitVoid();
                })
                .catch(() => {});
        },

        submitVoid() {
            this.$api({
                url: '/InvoiceManagemnetPage/VoidInvoice',
                method: 'post',
                data: {
                    sno: this.form.sno,
                    foO_CNL_DAT: Date.now(),
                    foO_CNL_MEM: '申請人自行撤銷',
                },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '發票已撤銷。',
                        type: 'success',
                    });
                    this.$router.push({ name: 'invoice' });
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        // 滑動到錯誤欄位
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        // 發票項目最後加總欄位控制 (elmentsUI)
        invoiceItemsGetSummary(param) {
            const { columns, data } = param;
            const sums = [];

            // 每一格
            columns.forEach((column, index) => {
                // 第一格
                if (index === 0) {
                    sums[index] = '發票項目總額（未稅）';
                    return;
                }

                // 其他格
                if (column.property === 'amt') {
                    const values = data.map((item) => Number(item[column.property]));
                    if (!values.every((value) => Number.isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!Number.isNaN(value)) {
                                return prev + curr;
                            }
                            return prev;
                        }, 0);
                        const SUM = this.form.cny === 'TWD' ? Math.round(Number(sums[index])) : Math.round(Number(sums[index]) * 10000) / 10000;
                        sums[index] = this.form.cny === 'TWD' ? `${SUM.toLocaleString('en')} 元` : `${accounting.formatMoney(SUM, { symbol: '', precision: 2 })} 元`;
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },

        onChangeCny() {
            this.form.rat = this.getCnyRat(this.form.cny);
            if (this.form.cny === 'TWD') {
                this.form.amt = Math.round(this.form.amt);
                this.nonTaxAmt = Math.round(this.nonTaxAmt);
                this.tax = Math.round(this.tax);
            }
            this.autoFillEmptyInstallmentsAmt();
        },

        onRefreshDescription() {
            this.updateAutoDescription();
        },

        getInvoiceValidateCode(item) {
            if (!item.foo) return undefined;
            const isIncome = true;
            const fooMonth = moment(item.foO_PDAT).month() + 1;
            const fooYear = moment(item.foO_PDAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) return Number(`${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`);

            return undefined;
        },
        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },
        onAhSuggestAccountingItemsSelectorLoaded() {
            this.isAhSuggestAccountingItemsSelectorShow = this.isPayed('G01') || this.$store.getters['account/isSAAdmin'];
        },
        onVaribleStateSelectorLoaded() {
            // force update value
            const sno = this.form.incomeItemNo;
            this.form.incomeItemNo = null;
            setTimeout(() => {
                this.form.incomeItemNo = sno;
                this.$nextTick(() => {
                    console.log(this.form.incomeItemNo);
                    this.$refs.ahSuggestAccountingItemsSelector?.init(this.form.incomeItemNo);
                });
            }, 2);
        },
        onDescriptionInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.invoice-add-page {
    .small-alert {
        margin: 3px 0 0 8px;
        line-height: 30px;
        padding: 3px 10px;
        display: inline-block;
        width: auto;
        vertical-align: top;

        .el-alert__description {
            margin-top: 0;
        }
    }
    .future-invoice-alert {
        margin-top: 10px;
        line-height: 30px;

        .el-alert__description {
            margin-top: 0;
        }
    }

    .invoice-item-table-area {
        margin-bottom: 10px;
        margin-left: 0px;

        @media (min-width: 992px) {
            margin-left: 200px;
        }
    }
    .invoice-item-table {
        border: 1px solid #ddd;
    }
    .invoice-item-table-below-contents {
        display: flex;
        margin: 15px 0;
        justify-content: space-between;
        gap: 20px;

        .note-text {
            font-size: 9pt;
            color: #888;
        }
    }

    .item-name input {
        padding-right: 55px;
    }

    .use-tax-included-checkbox {
        .el-checkbox__label {
            font-size: 9pt;
            font-weight: normal;
        }
    }
    .use-tax-included-hint {
        font-size: 9pt;
        color: #888;
    }
    .item-total-error-alert {
        list-style: 100%;
        .el-alert__description {
            margin-top: 0;
        }
    }
}
</style>
